/*
* SoundTouch JS audio processing library
* Copyright (c) Olli Parviainen
* Copyright (c) Ryan Berdeen
* Copyright (c) Jakub Fiala
* Copyright (c) Steve 'Cutter' Blades
*
* This library is free software; you can redistribute it and/or
* modify it under the terms of the GNU Lesser General Public
* License as published by the Free Software Foundation; either
* version 2.1 of the License, or (at your option) any later version.
*
* This library is distributed in the hope that it will be useful,
* but WITHOUT ANY WARRANTY; without even the implied warranty of
* MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
* Lesser General Public License for more details.
*
* You should have received a copy of the GNU Lesser General Public
* License along with this library; if not, write to the Free Software
* Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA
*/

export default class WebAudioBufferSource {
  constructor(
    private buffer: AudioBuffer,
  ) {
    // pass
  }

  extract(target: Float32Array, numFrames: number, position: number) {
    const left = this.buffer.getChannelData(0)
    const right = this.buffer.numberOfChannels > 1
      ? this.buffer.getChannelData(1)
      : this.buffer.getChannelData(0)
    let i = 0
    for (; i < numFrames; i++) {
      target[i * 2] = left[i + position]
      target[i * 2 + 1] = right[i + position]
    }
    return Math.min(numFrames, left.length - position)
  }
}
